import { render } from "./PrefixSettings.vue?vue&type=template&id=26fea951"
import script from "./PrefixSettings.vue?vue&type=script&lang=js"
export * from "./PrefixSettings.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__